// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import moment from 'moment'

import {
  castToString,
  ifEntityGetId,
  ifObjectGetValue,
} from 'helpers/reduxFormFunctions'

const formatRadioDataForDetails = entity => {
  const {
    architecture,
    atpcType,
    company: { companyId, companyName },
    createTimestamp,
    createUser,
    duplexMode,
    lastModifiedTimestamp,
    lastModifiedUser,
    modulationType,
    powerType,
    radioCode,
    radioFamily,
    radioId,
    radioType,
    stability,
    status,
  } = entity

  const createInfo = {
    timestamp: moment(createTimestamp).format('YYYY/MM/DD'),
    user: ifObjectGetValue(createUser, 'userName'),
  }

  const lastModifiedInfo = {
    timestamp: moment(lastModifiedTimestamp).format('YYYY/MM/DD'),
    user: ifObjectGetValue(lastModifiedUser, 'userName'),
  }

  const acap = castToString(entity.acap)
  const accp = castToString(entity.accp)
  const architectureId = ifEntityGetId(architecture)
  const atpcFlag = castToString(entity.atpcFlag)
  const atpcTypeId = ifEntityGetId(atpcType)
  const company = companyName
  const duplexModeId = ifEntityGetId(duplexMode)
  const dynamicPowerFlag = castToString(entity.dynamicPowerFlag)
  const extNarrowBwFilter = castToString(entity.extNarrowBwFilter)
  const familyInfo = radioFamily || { radioFamily: '', radioFamilyId: '' }
  const hiFrequency = castToString(entity.hiFrequency)
  const loFrequency = castToString(entity.loFrequency)
  const modulationLimit = castToString(entity.modulationLimit)
  const modulationTypeId = ifEntityGetId(modulationType)
  const powerTypeId = ifEntityGetId(powerType)
  const radioTypeId = ifEntityGetId(radioType)
  const specDate = moment(entity.specDate).format('YYYY/MM/DD')
  const stabilityId = ifEntityGetId(stability)
  const statusId = ifEntityGetId(status)
  const xpic = castToString(entity.xpic)

  return {
    ...familyInfo,
    acap,
    accp,
    architectureId,
    atpcFlag,
    atpcTypeId,
    company,
    companyId,
    createInfo,
    duplexModeId,
    dynamicPowerFlag,
    extNarrowBwFilter,
    hiFrequency,
    loFrequency,
    lastModifiedInfo,
    modulationLimit,
    modulationTypeId,
    powerTypeId,
    radioCode,
    radioId,
    radioTypeId,
    specDate,
    stabilityId,
    statusId,
    xpic,
  }
}

export default formatRadioDataForDetails
